export default __webpack_public_path__ + "static/media/aib_logo.1f5bd901.png";